import { sortBy, get } from 'lodash';
import OrderService from './order-service';

let formatMessage = null;
const setFormatMessage = fm => {
  formatMessage = fm;
};

const processProducts = products => {
  products.forEach(product => {
    const result = get(product, 'toppings', []) || [];
    result
      .map(topping => {
        return topping.topping_category_index;
      })
      .sort((a, b) => {
        return b - a;
      });
    product.toppings = result;
    //make groups using the Toppings_category
    product.groupedToppings = groupToppingsByCategory(product.toppings);
    //sorted topping by parentId
    product.orderedToppings = orderToppings(product.toppings);
    product.quantityText = `${product.units}x`;
    //validates that if have toppings
    const thereAreToppings = product.toppings.some(
      topping => topping.units > 1,
    );
    // show message of remminder for Toppings when is more than 1 of itselfs
    product.toppingMessage = thereAreToppings
      ? OrderService.getProductReminder(product, formatMessage)
      : false;
  });
};

const getProductsByCorridors = products => {
  const productsByCorridor = {};

  products.forEach(product => {
    if (!productsByCorridor[product.corridor_id]) {
      const productByCorridor = {};
      productByCorridor.corridor_id = product.corridor_id;
      productByCorridor.corridor_name = product.corridor_name;
      productByCorridor.products = [product];

      productsByCorridor[product.corridor_id] = productByCorridor;
    } else {
      productsByCorridor[product.corridor_id].products = [
        ...productsByCorridor[product.corridor_id].products,
        product,
      ];
    }
  });
  return productsByCorridor;
};

const groupToppingsByCategory = toppings => {
  const toppingCategories = [];
  for (const topping of toppings) {
    const existingToppingCategory = toppingCategories.find(
      tc => tc.name === topping.topping_category,
    );
    if (existingToppingCategory) {
      existingToppingCategory.toppings.push(topping);
      continue;
    }
    const toppingCategory = {
      index: topping.topping_category_index,
      name: topping.topping_category,
      toppings: [topping],
    };

    toppingCategories.push(toppingCategory);
  }
  return sortToppingCategoriesAndToppingsByIndex(toppingCategories);
};

const sortToppingCategoriesAndToppingsByIndex = toppingCategories => {
  // Sort topping categories by index and then by name.
  toppingCategories = sortBy(toppingCategories, ['index', 'name']);

  for (const toppingCategory of toppingCategories) {
    // Sort toppings of each topping category by topping index and then by description
    toppingCategory.toppings = sortBy(toppingCategory.toppings, [
      'topping_index',
      'description',
    ]);
  }
  return toppingCategories;
};

//TODO: homologar con la lógica de anidamiento usado en la comanda
function orderToppings(toppings = []) {
  function compareToppings(a, b) {
    if (a.topping_category_index !== b.topping_category_index) {
      return a.topping_category_index - b.topping_category_index;
    }

    if (a.topping_index !== b.topping_index) {
      return a.topping_index - b.topping_index;
    }

    if (a.topping_category !== b.topping_category) {
      return a.topping_category.localeCompare(b.topping_category);
    }

    return a.description.localeCompare(b.description);
  }

  function reGroupByCategory(listOfToppings) {
    return listOfToppings
      .reduce((acc, t) => {
        const _groupT = acc.find(a => a[0] === t.topping_category);
        if (_groupT === undefined) acc.push([t.topping_category, [t]]);
        else _groupT[1].push(t);
        return [...acc];
      }, [])
      .flatMap(gt => gt[1]);
  }

  let roots = toppings
    .filter(topping => topping.parent_id === null)
    .sort(compareToppings);
  roots = reGroupByCategory(roots);

  if (roots.length === 0) {
    return toppings;
  }

  function buildOrderedTree(currentTopping, level, result) {
    currentTopping.level = level;
    result.push(currentTopping);

    let children = toppings
      .filter(t => t.parent_id === currentTopping.id)
      .sort(compareToppings);
    children = reGroupByCategory(children);

    children.forEach(child => {
      buildOrderedTree(child, level + 1, result);
    });
  }

  const orderedResult = [];
  roots.forEach(root => {
    buildOrderedTree(root, 0, orderedResult);
  });

  return orderedResult;
}

export default {
  getProductsByCorridors,
  processProducts,
  setFormatMessage,
};
